{
  "external.scopes": "Ámbitos autorizados",
  "external.selectAll": "Seleccionar todos los actuales",
  "external.futureScopes": "Los ámbitos nuevos requerirán autorización explícita.",
  "external.channels": "Canales",
  "external.api": "API",
  "external.mcp": "MCP",
  "external.permission": "Permisos",
  "external.readOnly": "Solo lectura",
  "external.readWrite": "Lectura y escritura",
  "external.advanced": "Permisos avanzados",
  "external.deletePermission": "Permitir eliminar tareas y eventos por API",
  "external.expiry": "Caducidad",
  "external.noExpiry": "Deja la fecha vacía para no poner caducidad.",
  "external.save": "Guardar",
  "external.cancel": "Cancelar",
  "external.probeFailed": "La comprobación MCP ha fallado (HTTP {status}). Revisa el canal y los permisos de lectura.",
  "external.switchHelp": "Pausa el acceso externo sin borrar las credenciales. También afecta a los agentes IA. La web y Android siguen funcionando.",
  "external.apiEnabled": "Activar acceso API externo",
  "external.mcpEnabled": "Activar acceso MCP",
  "external.connect": "Conectar una aplicación",
  "external.client": "Aplicación",
  "external.client.chatgpt": "ChatGPT",
  "external.client.claude": "Claude",
  "external.client.hermes": "Hermes",
  "external.guide.chatgpt": "En ChatGPT, activa el modo desarrollador si tu cuenta lo permite. Añade un servidor MCP en plugins/conectores, pega esta URL y selecciona OAuth. Se abrirá Fem-ho para iniciar sesión y autorizarlo. La disponibilidad depende de la cuenta y la política del espacio de trabajo.",
  "external.guide.claude": "En Claude, ve a Ajustes → Conectores → Añadir conector personalizado. Pega esta URL y conéctalo. Autoriza los ámbitos y permisos en Fem-ho cuando se abra el navegador.",
  "external.guide.hermes": "Añade esta entrada a mcp_servers del archivo de configuración de Hermes. Al conectar, completa la autorización OAuth en el navegador. Después pide whoami y list_tasks para comprobar el acceso.",
  "external.oauthPermissions": "Cada conexión autoriza sus propios ámbitos y permisos. Puedes revocarla en la lista de credenciales. La URL debe ser HTTPS y accesible desde el cliente.",
  "external.manual": "Alternativa con token manual",
  "external.envHelp": "Crea un token con canal MCP y define FEMHO_MCP_TOKEN en el entorno de Hermes. El secreto solo se muestra una vez.",
  "external.documentation": "Ver la documentación oficial",
  "external.check": "Comprobar conexión MCP",
  "external.verified": "Conexión verificada: identidad y lectura de tareas correctas.",
  "external.closeSecret": "Ya he guardado el token",
  "external.agentCredential": "Credencial de agente IA",
  "external.oauthCredential": "Conexión OAuth",
  "external.unavailableScope": "Ámbito no disponible",
  "external.inheritedScopes": "Hereda los ámbitos del agente",
  "external.emptyScopes": "Sin ámbitos: edita el token para darle acceso.",
  "external.permissionsDetail": "Permisos detallados",
  "external.lastUsed": "Último uso: {date}",
  "external.expires": "Caduca: {date}",
  "external.never": "Sin caducidad",
  "external.revoked": "Revocado",
  "external.expired": "Caducado",
  "external.paused": "Pausado",
  "external.active": "Activo",
  "external.edit": "Editar",
  "external.reconnect": "Para cambiar los permisos, revoca esta conexión y vuelve a conectar desde la aplicación.",
  "external.authorize": "Autorizar conexión a Fem-ho",
  "external.consentHelp": "Esta aplicación podrá acceder a todas las tareas de los ámbitos que selecciones, incluido Inbox. Elige solo los permisos que necesite.",
  "external.enableForConsent": "Activar mi acceso MCP y autorizar esta conexión",
  "external.allow": "Autorizar",
  "external.deny": "Denegar",
  "settings.mail.pollInterval": "Consulta del correo",
  "settings.mail.pollDefault": "Por defecto · 5 minutos",
  "settings.mail.pollMinutes": "Cada {count} min",
  "settings.mail.pollHelp": "Consulta periódica, no inmediata. Puede tardar hasta 30 segundos más; los errores retrasan los reintentos.",
  "settings.mail.oauth.title": "Gmail y Google Workspace",
  "settings.mail.oauth.help": "Autoriza el acceso con Google y vuelve aquí para confirmar la dirección. Fem-ho leerá el correo sin modificar los mensajes.",
  "settings.mail.oauth.confirmEmail": "¿Conectar el correo {email}?",
  "settings.mail.oauth.connected": "Conectado con Google",
  "settings.mail.oauth.disconnected": "Google desconectado",
  "settings.mail.oauth.reconnect_required": "Hay que volver a autorizar Google",
  "settings.mail.oauth.pending": "Completa la autorización en el navegador y vuelve a esta pantalla.",
  "settings.mail.oauth.confirm": "Confirma la conexión",
  "settings.mail.oauth.cancel": "Cierra o cancela",
  "settings.mail.oauth.account": "Cuenta de Google",
  "settings.mail.oauth.new": "Conecta una cuenta nueva",
  "settings.mail.oauth.connect": "Conecta con Google",
  "settings.mail.oauth.reconnect": "Vuelve a conectar Google",
  "settings.mail.oauth.disconnect": "Desconecta Google",
  "settings.mail.oauth.error.cancelled": "Autorización cancelada. La cuenta no se ha modificado.",
  "settings.mail.oauth.error.expired": "El intento ha caducado. Vuelve a conectar Google.",
  "settings.mail.oauth.error.missing_scope": "Google no ha concedido el permiso de correo necesario para IMAP.",
  "settings.mail.oauth.error.missing_refresh_token": "Google no ha concedido acceso continuado. Vuelve a autorizar la cuenta.",
  "settings.mail.oauth.error.identity_mismatch": "Has elegido otro correo de Google. Selecciona la dirección de la cuenta que quieres reconectar.",
  "settings.mail.oauth.error.account_exists": "Este correo ya existe. Selecciónalo en la lista para reconectarlo.",
  "settings.mail.oauth.error.not_configured": "El administrador debe configurar OAuth de Google en esta instancia.",
  "settings.mail.oauth.error.reconnect_required": "Google ha revocado o ha hecho caducar el acceso. Vuelve a conectar la cuenta.",
  "settings.mail.oauth.error.not_ready": "La autorización aún no está preparada. Complétala en el navegador o inicia otro intento.",
  "settings.mail.oauth.error.generic": "No se ha podido completar la conexión con Google. Vuelve a intentarlo.",
  "$comment": [
    "Catalogo castellano. ca.json es la fuente de verdad de las CLAVES: este fichero debe",
    "tener exactamente el mismo conjunto, y i18n-parity falla si no es asi.",
    "",
    "Una clave que falte aqui no es un agujero: t() cae al catalan, que se lee. Una clave",
    "que falte en todas partes muestra la clave misma, que es un error de programa y tiene",
    "que verse. Son dos fallos distintos y se mantienen distintos.",
    "",
    "Convenciones, las mismas que ca.json: sentence case en todas partes, MAYUSCULAS solo",
    "en los epigrafes pequenos, el punto volado · como separador, los botones que anaden",
    "con un + literal, los marcadores de posicion acaban en … de un solo caracter, frases",
    "enteras en los estados vacios, y NINGUN EMOJI."
  ],
  "activity.filter.ai": "Solo IA",
  "activity.filter.all": "Todo",
  "activity.filter.human": "Solo personas",
  "activity.undo": "Deshacer",
  "activity.verb.answered": "has respondido",
  "activity.verb.asked": "te ha preguntado",
  "activity.verb.cascade_complete": "se ha completado en cascada",
  "activity.verb.claimed": "ha reservado la tarea",
  "activity.verb.commented": "ha comentado",
  "activity.verb.completed": "ha completado",
  "activity.verb.created": "ha creado la tarea",
  "activity.verb.deleted": "ha borrado",
  "activity.verb.moved": "ha movido",
  "activity.verb.refreshed": "ha refrescado el origen",
  "activity.verb.released": "ha liberado la tarea",
  "activity.verb.reopened": "ha reabierto",
  "activity.verb.token_created": "ha creado un token",
  "activity.verb.token_revoked": "ha revocado un token",
  "activity.verb.updated": "ha cambiado",
  "ai.attention.attachHint": "Lo que adjuntes a la tarea le llega con el trabajo.",
  "ai.attention.card": "Espera respuesta",
  "ai.attention.pending": "{count} tareas esperan tu respuesta",
  "ai.attention.waiting": "El agente espera una respuesta tuya para poder seguir. Se va cuando respondas.",
  "ai.coverage.disabled": "El agente «{agent}», que lleva «{scope}», está parado: no cogerá nada.",
  "ai.coverage.fix": "Asignar uno",
  "ai.coverage.none": "Ningún agente lleva «{scope}»: lo que dejes aquí se quedará sin hacer.",
  "ai.lock.card": "El agente trabaja en ella",
  "ai.lock.working": "El agente está trabajando en ella. Se desbloquea sola a las {time}.",
  "ai.mode.assisted": "Con ayuda",
  "ai.mode.cycle": "Cambia el modo de IA",
  "ai.mode.delegated": "IA",
  "ai.mode.manual": "Individual",
  "ai.proof.openTask": "Abre la tarea",
  "ai.proof.taskTitle": "Preparar la reunión del lunes",
  "ai.proof.toggleLease": "Reserva",
  "ai.readAt": "El agente lo leyó {when}.",
  "ai.status.configuredButUnused": "Hay credenciales de un modelo, y todavía no hay nada que las use.",
  "ai.status.credentialsWithoutProvider": "Hay una clave o un modelo configurados sin proveedor: no se usarán.",
  "ai.takeOver.action": "Me la quedo yo",
  "ai.takeOver.where": "¿A qué columna?",
  "ai.unseen": "Ha habido un cambio autónomo que no has visto",
  "app.name": "Fem-ho",
  "board.card.advance": "Mover a {column}",
  "board.column.doing": "Haciendo",
  "board.column.done": "Hecho",
  "board.column.inbox": "Inbox",
  "board.column.todo": "Por hacer",
  "board.done.backToToday": "Volver a hoy",
  "board.done.clear": "Limpiar",
  "board.done.emptyDay": "Ninguna tarea hecha el {day}.",
  "board.done.showAllToday": "Todo hoy",
  "board.done.thisWeek": "Esta semana",
  "board.done.yesterday": "Ayer",
  "board.drag.cancelled": "Movimiento cancelado.",
  "board.drag.grabbed": "{title} cogida. Usa las flechas para moverla y espacio para soltarla.",
  "board.drag.moved": "{title} movida a {column}.",
  "board.empty.doing": "Nada en marcha ahora mismo.",
  "board.empty.done": "Todavía no has acabado nada hoy.",
  "board.empty.inbox": "Ninguna tarea en la bandeja.",
  "board.empty.todo": "Ninguna tarea por hacer.",
  "board.fullEdit": "Edición completa",
  "board.ia.badge": "Kanban de la IA",
  "board.ia.empty": "La IA no tiene nada en esta columna.",
  "board.ia.newTask": "Nueva tarea para la IA",
  "board.ia.toggle": "Kanban de la IA",
  "board.others": "Ver tareas de otros",
  "board.quickAdd.failed": "No se ha podido crear. Inténtalo de nuevo.",
  "board.quickAdd.placeholder.person": "+ Añadir a {column}… @Persona",
  "board.quickAdd.placeholder.plain": "+ Añadir a {column}…",
  "board.quickAdd.placeholder.scope": "+ Añadir a {column}… #Ámbito",
  "board.quickAdd.revert": "Devolver «{label}» a texto",
  "board.quickAdd.scopeRequired": "Indica el ámbito con #{scopes}",
  "board.quickAdd.scopeRequiredPrefix": "Indica el ámbito con #",
  "calendar.addOnDay": "Añadir una tarea este día",
  "calendar.day": "Diario",
  "calendar.empty.day": "Sin eventos ni tareas este día.",
  "calendar.empty.week": "Sin nada",
  "calendar.event.fromInbox": "Quitar de la bandeja",
  "calendar.event.inInbox": "Está en tu bandeja.",
  "calendar.event.notInInbox": "No está en tu bandeja: en el calendario sigue, pero no te reclama el día.",
  "calendar.event.toInbox": "Poner en la bandeja",
  "calendar.month": "Mensual",
  "calendar.nextMonth": "Mes siguiente",
  "calendar.noDate": "SIN DÍA",
  "calendar.prevMonth": "Mes anterior",
  "calendar.sources": "Fuentes",
  "calendar.sources.hide": "Ocultar «{name}» del calendario",
  "calendar.sources.show": "Ver «{name}» en el calendario",
  "calendar.week": "Semanal",
  "card.add": "Añadir subtarea o lista",
  "card.addPlaceholder": "Nueva subtarea… o #Lista elemento",
  "card.lists.collapsed": "▸ Listas ({count})",
  "card.lists.expanded": "▾ Listas ({count})",
  "checklist.addItem": "+ Añadir elemento…",
  "checklist.completed": "Completados",
  "checklist.completedInline": "Hechos en línea",
  "checklist.completedSection": "Hechos en una sección",
  "checklist.completedWhere": "Dónde van los ítems hechos",
  "checklist.count": "{done}/{total}",
  "checklist.done": "Lista completada. ¿La quitas de las fijadas?",
  "checklist.empty": "Esta lista todavía no tiene ningún elemento.",
  "checklist.keep": "Mantener",
  "checklist.pin": "Fijar",
  "checklist.showCompleted": "Completados",
  "checklist.toggleItem": "Marca o desmarca «{text}»",
  "checklist.unpin": "Quitar de las fijadas",
  "checklist.unpinAction": "Quitar",
  "dashboard.doing": "Haciendo ahora",
  "dashboard.empty.doing": "Nada en marcha ahora mismo.",
  "dashboard.empty.overdue": "No hay nada atrasado.",
  "dashboard.empty.today": "Nada para hoy.",
  "dashboard.overdue": "Atrasadas",
  "dashboard.overdueCount": "{count} atrasadas",
  "dashboard.pending": "{count} pendientes",
  "dashboard.quickAdd": "+ Añadir… #Ámbito @Persona",
  "dashboard.title": "Vista general",
  "dashboard.today": "Hoy",
  "error.body-required": "Un comentario vacío no dice nada: escribe el motivo.",
  "error.calendar-not-empty": "«{name}» todavía tiene {count} eventos. Muévelos o bórralos antes.",
  "error.calendar-read-only": "«{name}» es una fuente de solo lectura y no se puede escribir.",
  "error.cannot-delete-self": "No puedes borrar tu propia cuenta desde Admin. Pídeselo a otro administrador.",
  "error.capabilities-exceeded": "Ninguna de las capacidades pedidas es tuya: un token no puede hacer más que quien lo crea.",
  "error.capabilities-required": "Un token sin ninguna capacidad no puede hacer nada: elige al menos una.",
  "error.claimed-by-other": "Otro agente la tiene reservada durante {minutes} min más.",
  "error.confirmation-mismatch": "Para vaciar la instancia, escribe su nombre exacto: «{name}».",
  "error.email-taken": "Ya hay una cuenta con {email}.",
  "error.endpoint-required": "Hay que decir qué endpoint se da de baja.",
  "error.event-incomplete": "Un evento necesita calendario, título e instante de inicio.",
  "error.generic": "Algo ha fallado.",
  "error.human-took-over": "Esta tarea la ha asumido una persona: ya no es de la IA.",
  "error.invalid-ai-mode": "El modo tiene que ser individual, con ayuda o delegado.",
  "error.invalid-credentials": "Correo o contraseña incorrectos.",
  "error.invalid-email": "Esto no parece un correo.",
  "error.invalid-permission": "El permiso tiene que ser mirar, marcar o comentar. No existe el de edición.",
  "error.invalid-subscription": "A esta suscripción le faltan datos.",
  "error.invalid-timezone": "«{value}» no es ninguna zona horaria. Usa un nombre como Europe/Madrid.",
  "error.invalid-value": "«{value}» no es un valor de {field}. Los válidos son: {allowed}.",
  "error.invite-invalid": "Esta invitación no es válida, ya se ha usado o ha caducado.",
  "error.label-other-scope": "La etiqueta {name} es de otro ámbito. Créala también en este.",
  "error.last-admin": "Es el último administrador. La instancia se quedaría sin nadie que la pudiera administrar.",
  "error.last-owner": "{name} se quedaría sin ningún propietario. Haz propietario a alguien más primero.",
  "error.member-shape": "Un miembro es una persona o una suscripción de calendario, nunca las dos cosas ni ninguna.",
  "error.missing-capability": "Este token no tiene la capacidad «{capability}».",
  "error.name-required": "Un token sin nombre no se distingue de los otros, y entonces no se puede revocar ninguno con confianza.",
  "error.no-lease": "Esta tarea no está reservada.",
  "error.not-a-member": "{person} no es miembro de {scope}: no podría abrir la tarea.",
  "error.not-claimed": "Esta tarea no la tienes reservada.",
  "error.not-creatable": "Esto no se puede crear desde un lote.",
  "error.not-found": "Esto ya no está.",
  "error.not-owner": "El ámbito {name} solo lo puede borrar quien lo creó.",
  "error.not-undoable": "Esto no es un cambio autónomo de IA con valores anteriores: no hay nada que restaurar.",
  "error.occurrence-required": "Hay que saber qué ocurrencia se toca.",
  "error.parent-required": "Falta decir dónde va.",
  "error.password-too-short": "La contraseña tiene que tener como mínimo 10 caracteres.",
  "error.project-other-scope": "El proyecto {name} es de otro ámbito. Una tarea no cambia de ámbito editándola.",
  "error.reason-required": "Liberar una tarea necesita un motivo: el siguiente agente lo tiene que poder leer.",
  "error.retry": "Reintentar",
  "error.scope-forbidden": "Este token no llega a este ámbito. Ve: {visible}.",
  "error.scope-not-collective": "El ámbito {name} es individual: no tiene miembros. Los colectivos sí.",
  "error.scope-not-empty": "El ámbito {name} todavía tiene {contents}. Muévelo o bórralo antes.",
  "error.scope-required": "Esto siempre pertenece a un ámbito.",
  "error.setup-closed": "Esta instancia ya tiene administrador.",
  "error.share-revoked": "Este enlace está revocado: no se puede volver a abrir. Crea uno nuevo.",
  "error.source-url-required": "La fuente necesita una dirección.",
  "error.target-required": "Un enlace es para una tarea o para una lista, no para las dos ni para ninguna.",
  "error.task-locked": "El agente «{agent}» está trabajando en ella ahora mismo. Se desbloqueará sola dentro de {minutes} min.",
  "error.text-required": "Esto no puede quedar vacío.",
  "error.title-required": "El título no puede quedar vacío.",
  "error.too-many-attempts": "Demasiados intentos. Vuelve a probar dentro de {seconds} segundos.",
  "error.unauthenticated": "Hay que volver a entrar.",
  "error.unknown-entity": "Esto no es algo que se sincronice.",
  "error.unreachable": "El servidor no contesta. No es lo que has escrito: mira si la instancia está encendida.",
  "error.version-conflict": "Alguien más lo ha cambiado mientras tanto.",
  "error.weak-share-password": "La contraseña del enlace necesita {min} caracteres como mínimo.",
  "error.window-invalid": "Las fechas del periodo no son válidas.",
  "error.window-required": "Hace falta un periodo: sin él no se pueden expandir las repeticiones.",
  "error.wrong-component": "«{name}» es de tareas y no acepta eventos.",
  "error.wrong-password": "La contraseña actual no es correcta.",
  "inbox.day.next": "El día siguiente",
  "inbox.day.pick": "Elegir el día",
  "inbox.day.prev": "El día anterior",
  "inbox.day.today": "Hoy",
  "inbox.event.allDay": "Todo el día",
  "inbox.event.toTask": "Hacer una tarea",
  "inbox.eye.hide": "Quitar del inbox de Tareas",
  "inbox.eye.show": "Llevar al inbox de Tareas",
  "inbox.mail.noSubject": "(sin asunto)",
  "inbox.mail.unknownSender": "Sin remitente",
  "inbox.mailbox": "Qué se ve en la bandeja",
  "inbox.mailbox.all": "Todo",
  "inbox.mailbox.allHint": "Toda la bandeja: los ámbitos individuales y los compartidos",
  "inbox.mailbox.own": "Individuales",
  "inbox.mailbox.ownHint": "Solo lo que hay en tus ámbitos individuales",
  "inbox.mailbox.shared": "Compartidos",
  "inbox.mailbox.sharedHint": "Solo lo que hay en los ámbitos que compartes con alguien",
  "inbox.section.events": "Del calendario",
  "inbox.section.mail": "Del correo",
  "invite.done": "Ya puedes entrar con tu correo y esta contraseña.",
  "invite.mismatch": "Las dos contraseñas no coinciden.",
  "invite.password": "Contraseña",
  "invite.repeat": "Repítela",
  "invite.subtitle": "Este enlace sirve una sola vez.",
  "invite.title": "Elige tu contraseña",
  "invite.tooShort": "Tiene que tener como mínimo 10 caracteres.",
  "join.accept": "Entrar",
  "join.done": "Ya estás dentro",
  "join.invalid": "Esta invitación no es válida: puede que ya se haya usado o que haya caducado.",
  "join.subtitle": "{who} te invita a «{scope}»",
  "join.title": "Una invitación",
  "login.checkServer": "Comprobar",
  "login.email": "Correo",
  "login.error": "Correo o contraseña incorrectos.",
  "login.forgot": "¿Has olvidado la contraseña?",
  "login.insecure": "Esta dirección no va cifrada. Cualquiera de la red puede leer lo que pase por ella.",
  "login.password": "Contraseña",
  "login.register": "Crear una cuenta",
  "login.server": "Servidor",
  "login.serverHint": "La dirección de tu servidor de Fem-ho",
  "login.serverNewer": "El servidor es más nuevo que esta app. Actualízala.",
  "login.serverUnreachable": "No hay ningún Fem-ho en esta dirección.",
  "login.submit": "Entrar",
  "login.subtitle": "El gestor de tareas para ti y la familia",
  "nav.add": "Añadir",
  "nav.allProjects": "Todos los proyectos",
  "nav.back": "‹ Atrás",
  "nav.backToBoard": "‹ Volver al tablero",
  "nav.calendar": "Calendario",
  "nav.cancel": "Cancelar",
  "nav.close": "Cerrar",
  "nav.create": "Crear",
  "nav.dashboard": "Vista general",
  "nav.delete": "Borrar",
  "nav.estadistiques": "Estadísticas",
  "nav.lastScope": "Tiene que quedar al menos un ámbito activo.",
  "nav.logout": "Cerrar sesión",
  "nav.newChecklist": "+ Nueva lista",
  "nav.newChecklistFull": "Nueva lista de tareas sencillas",
  "nav.newProject": "+ Nuevo proyecto",
  "nav.newProject.client": "Nuevo cliente",
  "nav.noPinned": "Ninguna lista fijada. Fija una lista sencilla desde una tarea.",
  "nav.openDashboard": "Abre la vista general",
  "nav.pinned": "Listas fijadas",
  "nav.pinnedProgress": "{done} de {total} hechos",
  "nav.profile": "Tu cuenta",
  "nav.projectToggle": "Muestra u oculta el proyecto {name}",
  "nav.registre": "Registro",
  "nav.rename": "Renombrar",
  "nav.retry": "Reintentar",
  "nav.save": "Guardar",
  "nav.scopePicker": "En qué ámbito estás",
  "nav.scopeProjects": "Proyectos del ámbito {name}",
  "nav.scopeToggle": "Muestra u oculta el ámbito {name}",
  "nav.search": "Buscar",
  "nav.settings": "Ajustes",
  "nav.tasks": "Tareas",
  "nav.view": "Vista",
  "notify.reminder": "Recordatorio",
  "palette.empty": "Nada que coincida.",
  "palette.go": "Ir a",
  "palette.placeholder": "Escribe para ir a un sitio o buscar una tarea…",
  "palette.tasks": "Tareas",
  "quickadd.groupOwn": "Los míos",
  "quickadd.groupShared": "Compartidos",
  "register.error": "No se ha podido crear la cuenta.",
  "register.haveAccount": "Ya tengo cuenta",
  "register.name": "Nombre de usuario",
  "register.submit": "Crear la cuenta",
  "register.subtitle": "Elige un nombre y una contraseña. Podrás cambiarlo desde Ajustes.",
  "register.title": "Crear una cuenta",
  "registre.allProjects": "Todos los proyectos",
  "registre.allProjects.client": "Todos los clientes",
  "registre.chrono.addLane": "+ Añade un proyecto…",
  "registre.chrono.fit": "Ajusta",
  "registre.chrono.hint": "Arrastra un bloque para moverlo y los bordes para alargarlo. Se ajusta a 5 min.",
  "registre.chrono.zoom": "Zoom",
  "registre.col.person": "Persona",
  "registre.col.project": "Proyecto",
  "registre.col.project.client": "Cliente",
  "registre.col.task": "Tarea",
  "registre.col.time": "Dedicación",
  "registre.col.type": "Tipología",
  "registre.col.when": "Fecha y hora",
  "registre.day": "Día",
  "registre.empty": "Todavía no hay nada registrado en este periodo.",
  "registre.everyone": "Todos",
  "registre.export": "Exporta CSV",
  "registre.noProject": "Interno",
  "registre.noScopes": "Ningún ámbito activo lleva registro de dedicación. Se activa en Ajustes ▸ Ámbitos.",
  "registre.open": "Se está haciendo ahora mismo.",
  "registre.overtimeCell": "{time} fuera de horario",
  "registre.overtimeTotal": "{time} fuera de horario",
  "registre.period.all": "Todo",
  "registre.period.days30": "Últimos 30 días",
  "registre.period.days90": "Últimos 90 días",
  "registre.period.month": "Este mes",
  "registre.period.today": "Hoy",
  "registre.period.week": "Esta semana",
  "registre.review": "Hace mucho rato seguido: vale la pena mirarlo.",
  "registre.search": "Busca…",
  "registre.subtitle": "Todas las tareas hechas: cuándo, para qué proyecto, quién y cuánta dedicación.",
  "registre.summary": "{tasks} tareas · {time} de dedicación registrada",
  "registre.timezone": "Las horas se ven en {zone}.",
  "registre.title": "Registro",
  "registre.view.chrono": "Cronograma",
  "registre.view.table": "Tabla",
  "settings.about": "Acerca de",
  "settings.accent": "Acento",
  "settings.accent.default": "Por defecto",
  "settings.accent.mono-cool": "Frío",
  "settings.accent.mono-warm": "Cálido",
  "settings.accent.soft": "Suave",
  "settings.addMember": "+ Añadir miembro",
  "settings.agentAllScopes": "Todos los ámbitos",
  "settings.agentCanCreate": "Puede crear tareas",
  "settings.agentConnect": "Cómo se conecta",
  "settings.agentCredentials": "Credenciales",
  "settings.agentDownloadMcp": "Descargar el .mcp.json",
  "settings.agentDownloadSkill": "Descargar la hoja de instrucciones",
  "settings.agentEnabled": "Activo",
  "settings.agentMcpHasToken": "Lleva la credencial: quien tenga este archivo puede leer y escribir tus tareas.",
  "settings.agentMcpNoToken": "Le falta la credencial: crea una y cópialo entonces, que es cuando se ve.",
  "settings.agentNewCredential": "+ Nueva credencial",
  "settings.agentScopeTaken": "Este ámbito lo lleva «{name}»: un ámbito solo puede tener un agente.",
  "settings.agentScopes": "Ámbitos que lleva",
  "settings.agentSkillNoToken": "No lleva ninguna credencial: es solo cómo debe comportarse.",
  "settings.agents": "Agentes",
  "settings.branding": "Logo de la instancia",
  "settings.branding.fixed": "El logo lo pone la configuración del servidor (FEMHO_LOGO_URL) y no se puede cambiar desde aquí.",
  "settings.branding.help": "SVG, PNG o WebP, como mucho 512 KB. Se ve en la barra, en el login y en la página de un enlace compartido.",
  "settings.branding.none": "Esta instancia todavía no tiene logo: se ve su nombre.",
  "settings.branding.remove": "Quitar el logo",
  "settings.caldavEvents": "Eventos",
  "settings.caldavTodos": "Tareas",
  "settings.caldavUrls": "Tus CalDAV de Fem-ho",
  "settings.calendarCredWarning": "Este calendario tiene credenciales guardadas. Los miembros verán sus eventos, pero las credenciales no salen nunca. Si además es bidireccional, lo que editen se escribirá en el servicio de un tercero con las tuyas.",
  "settings.calendarPrivate": "Solo para ti",
  "settings.calendarShared": "Compartido",
  "settings.calendarSource": "Origen CalDAV",
  "settings.changePassword": "Cambiar la contraseña",
  "settings.credits": "Fem-ho © 2026 Borja Balsera · El sistema de diseño es Plou, de un producto aparte y con condiciones propias · Tipografía Roboto (SIL Open Font License) · Ved el fichero NOTICE del repositorio",
  "settings.currentPassword": "Contraseña actual",
  "settings.dashboardItems": "Qué se ve en la vista general",
  "settings.day.fri": "vi",
  "settings.day.mon": "lu",
  "settings.day.sat": "sá",
  "settings.day.sun": "do",
  "settings.day.thu": "ju",
  "settings.day.tue": "ma",
  "settings.day.wed": "mi",
  "settings.empty.agents": "Todavía no has creado ningún agente.",
  "settings.empty.calendars": "Aún no hay contenido para Calendarios.",
  "settings.empty.shares": "Aún no hay contenido para Compartidos.",
  "settings.enableAi": "Activar el usuario IA",
  "settings.events.onDelete": "Al borrar una tarea hecha desde una cita",
  "settings.events.onDelete.hide": "La cita se queda fuera",
  "settings.events.onDelete.hideHint": "Sigue en el calendario, pero deja de reclamarte el día.",
  "settings.events.onDelete.return": "La cita vuelve a la bandeja",
  "settings.events.onDelete.returnHint": "Borrar la tarea deshace la conversión.",
  "settings.gravatar": "Usar Gravatar para mi foto",
  "settings.gravatarFill": "Rellenar con lo que hay en Gravatar",
  "settings.gravatarHelp": "El servidor pide tu foto a gravatar.com con el hash de tu correo. El hash no es anónimo: quien ya sospeche tu dirección puede comprobarla. Si lo quitas, se verán tus iniciales.",
  "settings.gravatarNothing": "Gravatar no tiene nada para este correo.",
  "settings.inbox.below": "Debajo",
  "settings.inbox.left": "Izquierda",
  "settings.inbox.right": "Derecha",
  "settings.inboxPosition": "Posición del raíl de Inbox",
  "settings.inboxShowOverdue": "El Inbox enseña las atrasadas",
  "settings.invite": "Invitar a alguien",
  "settings.inviteCreate": "Crear la invitación",
  "settings.inviteEmail": "Correo",
  "settings.inviteLink": "Enlace de invitación",
  "settings.inviteName": "Nombre",
  "settings.inviteNone": "Ninguna invitación abierta.",
  "settings.inviteOnce": "Cópiala ahora: no se podrá volver a ver.",
  "settings.inviteOpen": "Invitaciones abiertas",
  "settings.invitePending": "Invitado, todavía no ha entrado",
  "settings.inviteRevoke": "Revocar",
  "settings.inviteRole": "Qué podrá hacer",
  "settings.language": "Idioma",
  "settings.longSession": "Marca para revisar a partir de (horas)",
  "settings.mail.accounts": "Cuentas",
  "settings.mail.add": "Añadir la cuenta",
  "settings.mail.addRule": "Mapear la carpeta",
  "settings.mail.appPassword": "Fastmail e iCloud necesitan una contraseña de aplicación. En Gmail personal, activa la verificación en dos pasos y usa la contraseña de aplicación de 16 caracteres; puedes pegarla con espacios. Si el administrador de Google Workspace exige OAuth, Fem-ho todavía no puede conectar la cuenta.",
  "settings.mail.attachmentsToTask": "Los adjuntos del correo, en la tarea",
  "settings.mail.bodyToDescription": "El cuerpo del correo, en la descripción",
  "settings.mail.empty": "Todavía no hay ninguna cuenta de correo.",
  "settings.mail.firstRun": "La primera lectura de una carpeta no ingiere nada: se empieza desde ahora.",
  "settings.mail.folder": "Carpeta",
  "settings.mail.folderPlaceholder": "Nombre de la carpeta",
  "settings.mail.foldersFailed": "No se han podido leer. Escríbela.",
  "settings.mail.host": "Servidor IMAP",
  "settings.mail.inboxVisible": "Sale en el inbox de Tareas",
  "settings.mail.intro": "Las cuentas de correo son tuyas y no de la casa: nadie más las ve, ni el administrador.",
  "settings.mail.lastPolled": "Última lectura: {when}",
  "settings.mail.loadingFolders": "Leyendo las carpetas…",
  "settings.mail.name": "Nombre",
  "settings.mail.neverPolled": "Todavía no se ha leído.",
  "settings.mail.notTouched": "Nada marca tus correos como leídos.",
  "settings.mail.password": "Contraseña",
  "settings.mail.passwordKept": "Guardada. Déjala vacía.",
  "settings.mail.passwordKept.long": "Ya está guardada. Deja el campo vacío para no tocarla.",
  "settings.mail.pickFolder": "Elige una carpeta…",
  "settings.mail.port": "Puerto",
  "settings.mail.project": "Proyecto",
  "settings.mail.projectNone": "El espacio general",
  "settings.mail.remove": "Quitar",
  "settings.mail.rules": "Carpetas",
  "settings.mail.rules.empty": "Ninguna carpeta mapeada. Una carpeta sin regla no se lee nunca.",
  "settings.mail.save": "Guardar",
  "settings.mail.scope": "Ámbito",
  "settings.mail.security": "Seguridad",
  "settings.mail.security.starttls": "STARTTLS · puerto 143",
  "settings.mail.security.tls": "TLS · puerto 993",
  "settings.mail.template": "Título de la tarea",
  "settings.mail.templatePreset": "Remitente - Asunto",
  "settings.mail.templatePreview": "Se verá: {preview}",
  "settings.mail.templateUnknown": "Variables que no existen: {vars}",
  "settings.mail.test": "Probar la conexión",
  "settings.mail.testFail": "No ha ido: {error}",
  "settings.mail.testOk": "Conectado. {count} carpetas.",
  "settings.mail.testing": "Probando…",
  "settings.mail.username": "Usuario",
  "settings.mcpEnable": "Activar MCP",
  "settings.mcpInstructions": "Para conectar un cliente, usa esta dirección y un token con las capacidades que le quieras dar.",
  "settings.mcpUrl": "URL MCP",
  "settings.memberRemove": "Quitar",
  "settings.members": "Miembros",
  "settings.newAgent": "+ Nuevo agente",
  "settings.newCalendar": "+ Nuevo calendario",
  "settings.newPassword": "Contraseña nueva",
  "settings.newProject": "Proyecto nuevo",
  "settings.newScope": "+ Nuevo ámbito",
  "settings.noProjects": "Ningún proyecto en este ámbito.",
  "settings.noun.client": "Clientes",
  "settings.noun.project": "Proyectos",
  "settings.overtimeVisible": "Mostrar las horas fuera de horario como extra",
  "settings.passwordChanged": "Contraseña cambiada. Se han cerrado las otras sesiones.",
  "settings.profileEmail": "Correo",
  "settings.profileName": "Nombre",
  "settings.projectDelete": "Borrar el proyecto",
  "settings.projectName": "Nombre del proyecto",
  "settings.projects": "Proyectos",
  "settings.projectsHelp": "Un proyecto vive dentro de un ámbito. En la añadida rápida se llega con #Ámbito/Proyecto.",
  "settings.role.admin": "Administrador",
  "settings.role.collaborator": "Colaborador",
  "settings.role.member": "Miembro",
  "settings.role.owner": "Propietario",
  "settings.role.viewer": "Solo lectura",
  "settings.scopeCancel": "Cancelar",
  "settings.scopeColor": "Color",
  "settings.scopeDelete": "Eliminar el ámbito",
  "settings.scopeDeleteConfirm": "Se eliminará «{name}». Solo es posible si está vacío.",
  "settings.scopeEdit": "Editar",
  "settings.scopeJoin": "Sincronizar",
  "settings.scopeKind": "Tipo",
  "settings.scopeKind.collective": "Colectivo",
  "settings.scopeKind.individual": "Individual",
  "settings.scopeLeave": "Salir del ámbito",
  "settings.scopeLeaveConfirm": "Dejarás de ver «{name}» y lo que haya dentro.",
  "settings.scopeMode": "Cómo repartes el trabajo",
  "settings.scopeMode.both": "lo elige cada uno",
  "settings.scopeMode.fixed": "Esta instancia está configurada en «{mode}» y esto no se puede cambiar desde aquí.",
  "settings.scopeMode.help": "Puedes cambiarlo cuando quieras: no se mueve ni se borra nada, solo cambia qué hay en la barra de arriba.",
  "settings.scopeMode.multi": "Por ámbitos",
  "settings.scopeMode.multi.hint": "Los ámbitos en la barra: Personal, Trabajo, Familia… y los proyectos dentro de cada uno.",
  "settings.scopeMode.single": "Por proyectos",
  "settings.scopeMode.single.hint": "Los proyectos en la barra. Los ámbitos siguen existiendo y se eligen a la izquierda.",
  "settings.scopeName": "Nombre",
  "settings.scopeOwner": "Propietario",
  "settings.scopeSave": "Guardar",
  "settings.scopeServerUrl": "Dirección del servidor (https://…)",
  "settings.scopeSource.here": "De este servidor",
  "settings.scopeSource.new": "Nuevo",
  "settings.scopeSource.remote": "De otro servidor",
  "settings.scopeSourceHelp": "Quien comparte el ámbito te da un token. Si es de este mismo servidor solo hace falta el token; si es de otro, también la dirección.",
  "settings.scopeToken": "Pega el token de la invitación",
  "settings.sharedCalendars": "Calendarios que se comparten",
  "settings.showCalendarWidget": "Calendario en miniatura",
  "settings.showOverdueSection": "Sección de atrasadas",
  "settings.source": "Esta instancia usa Fem-ho {version}, bajo licencia {license}.",
  "settings.sourceLink": "El código",
  "settings.sources": "Fuentes de datos",
  "settings.sources.add": "+ Añadir fuente",
  "settings.sources.empty": "Este ámbito no tiene ninguna fuente externa. Las que añadas se verán en el calendario.",
  "settings.sources.failed": "El último refresco falló: {reason}",
  "settings.sources.inbox": "En la bandeja",
  "settings.sources.kind.caldav": "CalDAV",
  "settings.sources.kind.ical": "iCal",
  "settings.sources.kind.rss": "RSS",
  "settings.sources.name": "Nombre",
  "settings.sources.never": "Todavía no se ha refrescado.",
  "settings.sources.password": "Contraseña",
  "settings.sources.readOnly": "De solo lectura.",
  "settings.sources.refreshed": "Refrescada {when}.",
  "settings.sources.remove": "Quitar",
  "settings.sources.url": "Dirección",
  "settings.sources.urlRequired": "La fuente necesita una dirección.",
  "settings.sources.username": "Usuario",
  "settings.empty.admin": "Aún no hay contenido para Admin.",
  "settings.empty.ai": "Aún no hay contenido para Usuario IA.",
  "settings.empty.mail": "Aún no hay contenido para Correo.",
  "settings.empty.mcp": "Aún no hay contenido para MCP y API.",
  "settings.empty.profile": "Aún no hay contenido para Perfil.",
  "settings.empty.scopes": "Aún no hay contenido para Ámbitos.",
  "settings.tab.admin": "Admin",
  "settings.tab.ai": "Usuario IA",
  "settings.tab.calendars": "Calendarios",
  "settings.tab.general": "General",
  "settings.tab.mail": "Correo",
  "settings.tab.mcp": "MCP y API",
  "settings.tab.profile": "Perfil",
  "settings.tab.scopes": "Ámbitos",
  "settings.tab.shares": "Compartidos",
  "settings.theme": "Tema",
  "settings.theme.dark": "Oscuro",
  "settings.theme.light": "Claro",
  "settings.theme.system": "Sistema",
  "settings.timezone": "Zona horaria",
  "settings.title": "Ajustes",
  "settings.tracking": "Registro",
  "settings.trackingBackfilled": "Se han recuperado {count} bloques de dedicación del historial.",
  "settings.trackingHelp": "Cuando una tarea pasa por «Haciendo», el tiempo que está ahí queda registrado. Al activarlo se recupera lo que ya hay en el historial.",
  "settings.trackingOn": "Anotar la dedicación de este ámbito",
  "settings.typeNew": "Nueva tipología",
  "settings.typesOn": "Usar tipologías de tarea",
  "settings.typesRequired": "Obligatoria para crear una tarea",
  "settings.update.available": "Está la versión {version}.",
  "settings.update.see": "Ver qué ha cambiado",
  "settings.update.unreachable": "No se ha podido consultar si hay una versión más nueva.",
  "settings.users": "Miembros del hogar",
  "settings.weekStart": "Primer día de la semana",
  "settings.weekStart.auto": "Según el idioma ({day})",
  "settings.wipe": "Vaciar instancia",
  "settings.wipeConfirm": "Escribe «{name}» para confirmar",
  "settings.wipeWarning": "Esto borra todas las tareas, eventos, listas y el historial. Las cuentas se quedan.",
  "settings.workHours": "Horario laboral",
  "setup.name": "Tu nombre",
  "setup.scope.family": "Familia",
  "setup.scope.personal": "Personal",
  "setup.scope.work": "Trabajo",
  "setup.submit": "Crear la cuenta",
  "setup.subtitle": "Crea la primera cuenta de administrador de esta instancia.",
  "setup.title": "Empecemos",
  "share.accesses": "Accesos",
  "share.enter": "Entrar",
  "share.enterName": "¿Cómo te llamas?",
  "share.enterPassword": "Este enlace pide una contraseña",
  "share.expired": "Este enlace ya no es válido.",
  "share.expiresAt": "Caduca el",
  "share.lastAccess": "Último acceso",
  "share.maxViews": "Visitas máximas",
  "share.password": "Contraseña",
  "share.passwordPlaceholder": "Sin contraseña",
  "share.permission": "Qué puede hacer quien abra el enlace",
  "share.permission.check": "Marcar elementos",
  "share.permission.comment": "Marcar y comentar",
  "share.permission.view": "Solo mirar",
  "share.pointsTo": "Apunta a",
  "share.requireName": "Pedir el nombre a quien entre",
  "share.revoke": "Revocar",
  "share.revoked": "Revocado",
  "share.title": "Compartir",
  "share.wrong": "No hay manera de entrar con esto.",
  "shortcuts.calendar": "Calendario",
  "shortcuts.close": "Cerrar",
  "shortcuts.dashboard": "Vista general",
  "shortcuts.help": "Esta ayuda",
  "shortcuts.quickAdd": "Ir al añadido rápido",
  "shortcuts.scopeN": "Conmutar el ámbito N",
  "shortcuts.search": "Buscar",
  "shortcuts.settings": "Ajustes",
  "shortcuts.tasks": "Tareas",
  "shortcuts.title": "Atajos de teclado",
  "source.caldav": "De un calendario CalDAV",
  "source.ical": "De un calendario suscrito",
  "source.mail": "De un correo",
  "source.rss": "De un canal RSS",
  "state.empty.pinned": "No tienes ninguna lista fijada.",
  "state.empty.projects": "Este ámbito todavía no tiene ningún proyecto.",
  "state.empty.scopes": "Todavía no tienes ningún ámbito. Crea uno en Ajustes.",
  "state.empty.search": "No se ha encontrado nada.",
  "state.loading": "Cargando…",
  "stats.average": "Media por tarea",
  "stats.byPerson": "Dedicación por persona",
  "stats.byProject": "Dedicación por proyecto",
  "stats.byProject.client": "Dedicación por cliente",
  "stats.byType": "Dedicación por tipología",
  "stats.evolution": "Evolución de la dedicación",
  "stats.evolutionWeekly": "Evolución de la dedicación, por semanas",
  "stats.noType": "Sin tipología",
  "stats.overtime": "Horas extra por proyecto",
  "stats.overtime.client": "Horas extra por cliente",
  "stats.period.all": "Todo",
  "stats.period.days30": "Últimos 30 días",
  "stats.period.days365": "Último año",
  "stats.period.days7": "Últimos 7 días",
  "stats.period.days90": "Últimos 90 días",
  "stats.projects": "Proyectos activos",
  "stats.projects.client": "Clientes activos",
  "stats.subtitle": "Dedicación del equipo: por tipología, por proyecto, por persona y cómo evoluciona en el tiempo.",
  "stats.tasks": "Tareas hechas",
  "stats.title": "Estadísticas",
  "stats.total": "Dedicación total",
  "sync.appliedByServer": "Aplicadas por el servidor",
  "sync.complete": "Márcala",
  "sync.conflict": "Esta tarea ha cambiado en los dos lados. ¿Qué versión quieres?",
  "sync.goOffline": "Desconecta",
  "sync.goOnline": "Reconecta",
  "sync.keepMine": "La mía",
  "sync.keepTheirs": "La del otro dispositivo",
  "sync.now": "Sincroniza ahora",
  "sync.offline": "Sin conexión",
  "sync.online": "En línea",
  "sync.pending": "Pendiente de subir",
  "sync.remoteEdit": "Cambio desde otro dispositivo",
  "sync.rename": "Renombrar",
  "sync.renameSuffix": "·",
  "sync.synced": "Sincronizado",
  "sync.title": "Sincronización",
  "task.activity": "Historial",
  "task.addAttachment": "Adjuntar un archivo",
  "task.aiConversation": "Conversación con la IA",
  "task.aiInstructions": "Instrucciones para la IA",
  "task.aiMode": "Modo de IA",
  "task.aiReply": "Responde al agente…",
  "task.assignees": "Asignada a",
  "task.attachmentLink": "Enlace externo",
  "task.attachmentTooBig": "El archivo supera el límite de {limit_mb} MB.",
  "task.attachments": "Adjuntos",
  "task.checklists": "Listas sencillas",
  "task.comments": "Comentarios",
  "task.deadline": "Fecha límite",
  "task.deleteConfirm": "¿Quieres borrar definitivamente «{title}»? También se borrarán sus subtareas y listas. Si procede de un evento del calendario, el evento se conservará.",
  "task.description": "Descripción",
  "task.dueDate": "Fecha",
  "task.dueTime": "Hora",
  "task.edit": "Editar tarea",
  "task.empty.activity": "Todavía no ha pasado nada en esta tarea.",
  "task.empty.aiConversation": "Todavía no os habéis dicho nada.",
  "task.empty.attachments": "Ningún archivo adjunto.",
  "task.empty.comments": "Todavía no hay ningún comentario.",
  "task.empty.labels": "Este ámbito todavía no tiene ninguna etiqueta.",
  "task.empty.subtasks": "Esta tarea no tiene subtareas.",
  "task.label.add": "Poner esta etiqueta",
  "task.label.remove": "Quitar esta etiqueta",
  "task.labels": "Etiquetas",
  "task.new": "Nueva tarea",
  "task.newChecklist": "+ Nueva lista",
  "task.newComment": "Escribe un comentario…",
  "task.newLabel": "+ Nueva etiqueta",
  "task.newLabel.placeholder": "Nombre de la etiqueta",
  "task.newSubtask": "+ Añadir subtarea…",
  "task.noProject": "Espacio general",
  "task.project": "Proyecto",
  "task.project.client": "Cliente",
  "task.recurrence": "Repetición",
  "task.recurrence.daily": "Cada día",
  "task.recurrence.explain": "Con esto, la siguiente sale del día que la hagas y no del vencimiento.",
  "task.recurrence.fromCompletion": "Contar desde que se completa",
  "task.recurrence.monthly": "Cada mes",
  "task.recurrence.none": "No se repite",
  "task.recurrence.weekly": "Cada semana",
  "task.recurrence.yearly": "Cada año",
  "task.removeAttachment": "Quitar",
  "task.scope": "Ámbito",
  "task.send": "Envía",
  "task.share": "Compartir",
  "task.status": "Estado",
  "task.subtasks": "Subtareas",
  "task.taskType": "Tipología",
  "task.title": "Título",
  "task.titleEditHint": "Mantén pulsado el título y suelta para editarlo · F2 con el teclado",
  "task.titleEditKeys": "Intro para guardar · Escape para cancelar",
  "task.titleRequired": "El título no puede estar vacío.",
  "tokens.aiOwned": "Credencial de IA de «{name}»",
  "tokens.aiOwnedGo": "Ir al agente",
  "tokens.aiOwnedHelp": "Las credenciales de IA se crean y se revocan en Usuario IA, donde también se dice qué ámbitos lleva cada agente.",
  "tokens.capabilities": "Capacidades",
  "tokens.copied": "Copiado",
  "tokens.copy": "Copia",
  "tokens.create": "Crea un token",
  "tokens.lastUsed": "Último uso",
  "tokens.name": "Nombre",
  "tokens.never": "Nunca",
  "tokens.onceWarning": "Apúntalo ahora: no se podrá volver a ver nunca más.",
  "tokens.prefix": "Prefijo",
  "tokens.revoke": "Revoca",
  "tokens.scopes": "Ámbitos",
  "tokens.title": "Tokens de API",
  "welcome.changeable": "Puedes cambiarlo siempre que quieras en Ajustes. No se mueve ni se borra nada.",
  "welcome.lead": "Elige cómo quieres ver Fem-ho. No hay respuesta mala y se cambia cuando quieras.",
  "welcome.multi": "Por ámbitos de la vida",
  "welcome.multi.body": "Arriba tienes Personal, Trabajo, Familia… y puedes mirar uno o varios a la vez. Dentro de cada ámbito caben proyectos.",
  "welcome.preview.family": "Familia",
  "welcome.preview.personal": "Personal",
  "welcome.preview.projectA": "Obras",
  "welcome.preview.projectB": "Clientes",
  "welcome.preview.scope": "Trabajo",
  "welcome.preview.work": "Trabajo",
  "welcome.single": "Por proyectos de una sola cosa",
  "welcome.single.body": "Arriba tienes los proyectos. Va bien si usas Fem-ho para una sola cosa: tu trabajo, tu empresa, un proyecto.",
  "welcome.title": "¿Cómo repartes el trabajo?",
  "widget.board.description": "Elige Inbox, Por hacer o En curso y toca una tarea para avanzarla.",
  "widget.board.name": "Fem-ho · Tareas",
  "widget.more": "+{count} más",
  "widget.pending": "pendientes",
  "widget.pinned.choose": "Elige qué lista quieres ver",
  "widget.pinned.description": "Una lista fijada, para marcar desde la pantalla de inicio.",
  "widget.pinned.name": "Fem-ho · Lista",
  "widget.quickAdd.description": "Apunta una tarea sin abrir la app.",
  "widget.quickAdd.name": "Fem-ho · Añadir",
  "widget.signedOut": "Conéctate para ver tus tareas.",
  "widget.today.description": "Lo que vence hoy, con añadido rápido.",
  "widget.today.name": "Fem-ho · Hoy",
  "settings.noMembers": "Sin miembros.",
  "settings.scopeType": "Tipo",
  "settings.scopeType.individual": "Individual",
  "settings.scopeType.collective": "Colectivo",
  "settings.inviteUrl": "Enlace de invitación",
  "settings.invites": "Invitaciones",
  "settings.noInvites": "No hay invitaciones abiertas.",
  "settings.workStart": "Hora de inicio",
  "settings.workEnd": "Hora de finalización",
  "settings.workDays": "Días laborables",
  "settings.longSessionHours": "Horas de sesión larga",
  "settings.labelNew": "+ Nueva etiqueta",
  "settings.labelDelete": "Borrar la etiqueta",
  "settings.typeDelete": "Borrar la tipología",
  "settings.entityLabels": "Etiquetas",
  "settings.entityTypes": "Tipologías",
  "settings.entityDedication": "Dedicación",
  "settings.entityProjects": "Proyectos",
  "settings.scopeSection": "Gestión del ámbito",
  "notification.snooze": "Posponer",
  "login.certTitle": "Certificado no reconocido",
  "login.certBody": "El servidor presenta un certificado autofirmado o de una CA propia. Compara la huella con la que esperas y, si coincide, confírmala para conectar.",
  "login.certFingerprint": "Huella",
  "login.certConfirm": "Confiar en este certificado",
  "login.certReject": "Cancelar",
  "reports.title": "Informes",
  "reports.subtitle": "Qué has terminado y dónde has dedicado el tiempo.",
  "reports.tab.summary": "Resumen",
  "reports.tab.time": "Dedicación",
  "reports.tab.register": "Registro de tiempo",
  "reports.print": "Imprime / Guarda como PDF",
  "reports.values": "Muestra los valores",
  "reports.period": "Periodo",
  "reports.from": "Desde",
  "reports.to": "Hasta",
  "reports.period.today": "Hoy",
  "reports.period.week": "Semana actual",
  "reports.period.month": "Mes actual",
  "reports.period.days30": "Últimos 30 días",
  "reports.period.days90": "Últimos 90 días",
  "reports.period.all": "Todo",
  "reports.period.custom": "Personalizado",
  "reports.assignee": "Persona asignada",
  "reports.person": "Persona que registra tiempo",
  "reports.allTypes": "Todas las tipologías",
  "reports.invalidRange": "La fecha final debe ser igual o posterior a la inicial.",
  "reports.exportError": "No se ha podido exportar. Inténtalo de nuevo.",
  "reports.loading": "Cargando el informe…",
  "reports.trackingDisabled": "Los ámbitos seleccionados no tienen activado el registro de dedicación. El resumen de tareas sigue disponible.",
  "reports.configure": "Configura el registro de dedicación",
  "reports.current": "Estado actual",
  "reports.activity": "Actividad del periodo",
  "reports.completedHint": "Cuenta tareas que ahora están hechas y se completaron dentro del periodo. No incluye reabiertas ni eliminadas.",
  "reports.metric.pending": "Pendientes ahora",
  "reports.metric.overdue": "Atrasadas ahora",
  "reports.metric.created": "Creadas en el periodo",
  "reports.metric.completed": "Hechas en el periodo",
  "reports.evolution": "Evolución de las tareas",
  "reports.week": "Semana",
  "reports.projects": "Por proyecto",
  "reports.projects.client": "Por cliente",
  "reports.empty": "No hay resultados con estos filtros.",
  "reports.status": "Estado",
  "reports.trackedTasks": "Tareas con dedicación",
  "reports.trackedProjects": "Proyectos con dedicación",
  "reports.trackedProjects.client": "Clientes con dedicación",
  "reports.visibility": "La dedicación incluye tus bloques y los de todo el ámbito solo cuando tienes permiso para verlos.",
  "reports.firstPage": "Primera página",
  "reports.nextPage": "Página siguiente",
  "reports.generated": "Calculado el {at}",
  "reports.openSessions": "Incluye {count} sesiones en curso.",
  "error.invalid-report-filter": "Revisa las fechas, los proyectos y el tamaño de página del informe.",
  "reports.allProjects": "Todos",
  "reports.paginationHint": "Los totales incluyen todas las coincidencias. La lista muestra hasta 100 resultados por página.",
  "chrono.edit": "Edita el tiempo",
  "chrono.add": "Añade tiempo",
  "chrono.taskChoice": "Tarea",
  "chrono.newTask": "Tarea nueva",
  "chrono.existingTask": "Tarea existente",
  "chrono.title": "Título",
  "chrono.createdDone": "Se creará como hecha, con este bloque de dedicación.",
  "chrono.selectTask": "Selecciona una tarea",
  "chrono.refineSearch": "Hay más tareas. Afina la búsqueda para encontrarlas.",
  "chrono.start": "Inicio",
  "chrono.end": "Final",
  "chrono.running": "En curso",
  "chrono.moveWarning": "Confirmo que se moverá toda la tarea y toda su dedicación al proyecto seleccionado.",
  "chrono.saveError": "No se ha podido guardar. Revisa las horas, los permisos o si la sesión ha cambiado; se han recargado los datos.",
  "chrono.openTask": "Abre la tarea",
  "chrono.sameScope": "Elige un proyecto del mismo ámbito. El bloque no se ha movido.",
  "chrono.zoomOut": "Aleja",
  "chrono.zoomIn": "Acerca",
  "chrono.hint": "Arrastra los bordes para ajustar el tiempo, el bloque para moverlo o un espacio vacío para crear uno. Ajuste a 5 minutos. Pulsa el bloque para editar sin arrastrar.",
  "error.session-forbidden": "No puedes editar esta dedicación.",
  "error.session-conflict": "La sesión ha cambiado. Recárgala antes de editar.",
  "error.invalid-session": "Revisa los datos del bloque de dedicación.",
  "settings.showReports": "Mostrar Informes en la barra principal",
  "settings.showReportsHint": "Si lo desactivas, encontrarás Informes en el menú de tu foto de perfil.",
  "reports.tools": "Exportar o imprimir",
  "reports.exportContent": "Contenido del CSV",
  "reports.exportTasks": "Tareas · {metric}",
  "reports.registerTitle": "Tiempo registrado",
  "reports.registerHint": "El tiempo se registra al pasar por En curso o al indicar la duración al completar directamente una tarea. Cada tramo se conserva por separado.",
  "reports.filters": "Filtros",
  "reports.clearFilters": "Limpiar filtros",
  "reports.openRegister": "Abrir el registro de tiempo",
  "reports.timeDetails": "Desglose del tiempo",
  "reports.closeDetails": "Cerrar el detalle",
  "reports.recordedTasks": "Tiempo registrado en {count} tareas",
  "reports.seeCompleted": "Ver las tareas hechas",
  "reports.aboutData": "Sobre estos datos",
  "tracking.cardsTitle": "Dedicación en las tarjetas",
  "tracking.showCards": "Mostrar el tiempo en En curso y Hecho",
  "tracking.cardsHint": "Suma todos los tramos visibles. En curso, el contador avanza cada segundo; en Hecho, muestra el total. Solo en ámbitos con el registro activado.",
  "tracking.askDuration": "¿Cuánto tiempo le has dedicado?",
  "tracking.completionHint": "El ámbito tiene el registro de tiempo activado. Anota la duración para completar la tarea y añadir un tramo de trabajo.",
  "tracking.minutes": "Duración en minutos",
  "tracking.saveComplete": "Guardar el tiempo y marcar como hecha",
  "tracking.invalidDuration": "Introduce entre 1 y 10.080 minutos.",
  "tracking.total": "Dedicación: {duration}",
  "tracking.oneSegment": "1 tramo",
  "tracking.segments": "{count} tramos",
  "tracking.seconds": "{count}s",
  "widget.chooseColumn": "¿Qué quieres ver en el widget?",
  "widget.configure": "Configurar",
  "widget.columnEmpty": "No hay tareas en esta columna.",
  "widget.advance": "→ {column}",
  "widget.pendingSync": "Cambio guardado en el móvil. Pendiente de sincronizar.",
  "widget.taskBoard.name": "Fem-ho · Tablero",
  "widget.taskBoard.description": "Inbox, Por hacer y En curso. Toca una tarea para avanzarla.",
  "widget.taskBoard.open": "Abre",
  "widget.taskBoard.viewAll": "Ver todas",
  "widget.taskBoard.empty": "Sin tareas.",
  "widget.taskBoard.advance": "{task}. Mover a {column}.",
  "external.credentials": "Credenciales"
}
